<template>
  <div>
    <h1 class="page-header">{{ $t('hospitalProfile.pageTitle') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  search
                  :placeholder="$t('hospitalProfile.search')"
                  style="width: 300px"
                  class="kh-font"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-card-wrapper>
            <ts-table
              :columns="columns"
              :loading="loading"
              :records="resources"
            >
              <template v-slot="{ record }">
                <td>{{ record.hospital_name }}</td>
                <td>{{ record.address }}</td>
                <td>{{ record.contact_number }}</td>
                <td class="text-center">
                  <a
                    href="#"
                    title="edit"
                    class="text-primary mr-2"
                    @click.prevent="edit(record)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    title="delete"
                    class="text-danger"
                    @click.prevent="destroy(record.id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table>
            <ts-card-wrapper class="d-flex justify-content-end p-15">
              <ts-pagination v-model="pagination" @navigate="fetchData">
              </ts-pagination>
            </ts-card-wrapper>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import FormCreate from './form.vue'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  components: {
    FormCreate
  },
  name: 'hospital-profile',
  data () {
    return {
      loading: false,
      edit_data: this.editData,

      columns: [
        { name: this.$t('hospitalProfile.hospitalName') },
        { name: this.$t('hospitalProfile.address') },
        { name: this.$t('hospitalProfile.contactNumber') },
        {
          name: this.$t('actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('hospitalProfile', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.hospitalProfile.search
      },
      set (newVal) {
        this.$store.commit('hospitalProfile/SET_SEARCH', newVal)
        this.$store.commit('hospitalProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('hospitalProfile/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    edit (data) {
      this.edit_data = data
      this.$router.push(`/hospital-profiles/${data.id}`)
    },
    async destroy (id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('hospitalProfile/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
